if (!customElements.get('td-testimonial-media')) {
  class TDTestimonialMedia extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.td-testimonial-media__video');

      if (!this.video) {
        return;
      }

      // preload="none" — fetch only on first play().
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
    }
  }

  customElements.define('td-testimonial-media', TDTestimonialMedia);
}
